import { useTheme } from '@mui/material';
import Icon from 'components/icons/Icon';
const BetaIcon = () => {
  const theme = useTheme();
  return <Icon type="beta" style={{ color: theme.palette.primary.main, fontSize: '1rem' }} />;
};

export default BetaIcon;
